// extracted by mini-css-extract-plugin
export default {"container":"styles_container__M-164","content":"styles_content__P9dYW","cancel":"styles_cancel__NkZCc"};